import Button from '@/components/Button'
import Text from '@/components/Text'
import { ContentPageSection } from '@/shared/api-generated-types'
import DOMPurify from 'isomorphic-dompurify'
import * as styles from './style'

export interface Props extends Partial<ContentPageSection> {
  className?: string
}

const ContentBlock = ({ content, title, navigationActions, className = '' }: Props): JSX.Element => {
  // TODO: Implement TextContentCallOut on the API as a new type, perhaps clean up this implementation
  //@ts-ignore
  const hasCallOut = content?.__typename === 'TextContentCallOut'
  return (
    <div data-component="content-block-cp" className={`${hasCallOut ? styles.callout : ''} ${className}`}>
      {title ? (
        <Text weight="lg" responsiveSize={{ sm: 'md', lg: 'md', xl: 'lg' }}>
          {title}
        </Text>
      ) : null}
      <div
        className={`${!hasCallOut ? 'pb-lg pb-md-lte-smallTablet' : ''} ${styles.calloutList}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(content?.html ? content.html : content?.text.replaceAll('\n', '<br/>') || ''),
        }}
      />
      {navigationActions && navigationActions.length > 0 ? (
        <div className="pt-lg">
          {navigationActions.map((action, index) => (
            <Button
              theme={'primaryOutline' /* TODO: Get button themes from api */}
              key={index}
              href={'' /* TODO: Generate from targetPageId */}
              label={action?.label}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}
export default ContentBlock
